import { log } from 'log';
import { prop } from 'ramda';
import { MutableRefObject, useEffect } from 'react';
import { useSocketSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';

import * as Types from '../types';
import * as constants from '../constants';

export const useOnReconnect = ({
    sdk,
    nextTime,
    triggerGeolocation,
    setTransactionID,
    setNextTime,
    triggerTimestampRef
}: {
    sdk: Types.GeofencingSdkInstance | null;
    nextTime: number;
    triggerGeolocation: Types.TriggerGeolocationCallback;
    setTransactionID: (transactionID: string | null) => void;
    setNextTime: (nextTime: number) => void;
    triggerTimestampRef: MutableRefObject<number | null>;
}) => {
    const connected = useSocketSelector(prop('connected'));
    const prevConnected = usePrevious(connected);

    useEffect(() => {
        if (connected === prevConnected || !connected) {
            return;
        }

        if (!sdk || !nextTime) {
            return;
        }

        log('gcInfo', { event: 'connectionReconnected' });

        // unset current timeout
        triggerTimestampRef.current = null;
        setTransactionID(null);
        setNextTime(0);

        triggerGeolocation({
            reason: constants.GEOLOCATION_REASON.RECONNECT_CHECK
        });
    }, [
        sdk,
        nextTime,
        connected,
        prevConnected,
        setTransactionID,
        setNextTime,
        triggerGeolocation,
        triggerTimestampRef
    ]);
};
